import encodeUrl from 'encodeurl'
import qs from 'qs'
import To from 'await-to-js'
// eslint-disable-next-line import/no-cycle
import Callback from './callback'

/**
 * This provides mixins used for common api in the Vue components.
 * Before you begin to used it , plz inject this mixins in the components
 * like mixins: [ApiMixin]
 *
 * @mixin
 */
const ApiMixin = {
  async apiGetAllCode(params = {}) {
    const [err, res] = await To(axios.get('/api/tag/tags', { params }))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiGetCodeInformation(params = {}) {
    const [err, res] = await To(axios.get('/api/activity/get_all_parent_list', { params }))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiextrication(arg = { formData: {} }) {
    const [err, res] = await To(axios.post('/api/cable_reel/unbind', arg.formData))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUploadFiles(arg = { formData: {} }) {
    const [err, res] = await To(axios.post('/file/upload_files', arg.formData))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUploadFilesWithSiteId(arg = { formData: {}, params: { siteId: '' } }) {
    const [err, res] = await To(axios.post(`/file/upload_files/${arg.params.siteId}`, arg.formData))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async dictItem(arg = { method: 'list', params: { keyWord: ' ' } }) {
    const [err, res] = await To(
      axios.get(encodeUrl(`api/dicitem/getdicitembynameasync/${arg.params.keyWord}`))
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiSSO(arg = { params: {} }) {
    // const [err, res] = await To(
    //   axios.get(
    //     `${currentEnv.VUE_APP_EASC_SERVER}/loginbythirttoken/${currentEnv.VUE_APP_APP_ID}/${
    //       arg.params.token
    //     }`
    //   )
    // )
    const formData = new FormData()
    formData.append('token', arg.params.token)
    formData.append('appId', currentEnv.VUE_APP_APP_ID)
    const [err, res] = await To(
      axios.post(`${currentEnv.VUE_APP_EASC_SERVER}/loginbythirttoken`, formData)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiSignUrlName(arg = { params: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    arg.params.appId = currentEnv.VUE_APP_APP_ID
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/loginusername`, arg.params)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUserSign(arg = { formData: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (arg.formData) {
      arg.formData.append('appId', currentEnv.VUE_APP_APP_ID)
    }
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/login`, arg.formData)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiSiteList() {
    const [err, res] = await To(axios.get('/api/Sites/GetSitesAsync'))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUserAuth(arg = { params: {} }) {
    const objList = {
      appId: currentEnv.VUE_APP_APP_ID,
      userId: ' ',
    }
    if (arg.params) {
      _.assign(objList, arg.params)
    }
    const [err, res] = await To(
      axios.get(
        encodeUrl(
          `${currentEnv.VUE_APP_EASC_SERVER}/auth/applicationpermissionsasync/${objList.appId}/${objList.userId}`
        )
      )
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUserList(arg = { params: {} }) {
    _.assign(arg, {
      appId: currentEnv.VUE_APP_APP_ID,
    })
    const [err, res] = await To(
      axios.get(`${currentEnv.VUE_APP_EASC_SERVER}/org/getallorgswithuserdata/${arg.appId}`)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUserInfo() {
    const [err, res] = await To(axios.get(`${currentEnv.VUE_APP_EASC_SERVER}/userinfo`))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiRefreshReq(arg = { refreshToken: '' }) {
    _.assign(arg, {
      appId: currentEnv.VUE_APP_APP_ID,
    })
    const [err, res] = await To(
      axios.get(`${currentEnv.VUE_APP_EASC_SERVER}/refreshtoken/${arg.appId}/${arg.refreshToken}`)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // 新增修改密码
  async apiChangePwd(arg = { formData: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (arg.formData) {
      arg.formData.append('appId', currentEnv.VUE_APP_APP_ID)
    }
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/changepassword`, arg.formData)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiUrlToken(arg = { formData: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (arg.formData) {
      arg.formData.append('appId', currentEnv.VUE_APP_APP_ID)
    }
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/loginbytoken`, arg.formData)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // 获取加密公钥
  async apiGetPubKey() {
    const [err, res] = await To(axios.get(`${currentEnv.VUE_APP_EASC_SERVER}/getrsapublickey`))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // rsa登陆接口
  async apiRsaLogin(arg = { formData: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (arg.formData) {
      arg.formData.append('appId', currentEnv.VUE_APP_APP_ID)
    }
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/rsalogin`, arg.formData)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  async apiRsaSign(arg = { params: {} }) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (arg.params) {
      arg.params.AppId = currentEnv.VUE_APP_APP_ID
    }
    const [err, res] = await To(
      instance.post(`${currentEnv.VUE_APP_EASC_SERVER}/validatecodelogin`, arg.params)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // 获取所有用户数据
  async apiUsersData() {
    const [err, res] = await To(axios.get('/api/Users/getuserslistasync'))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // 获取登录验证码
  async apiValidateCode() {
    const instance = axios.create({})
    const [err, res] = await To(instance.get(`${currentEnv.VUE_APP_EASC_SERVER}/GetValidationCode`))
    return Callback.globalCB(err, res, { errorMsg: false })
  },
  // 根据authcode获取token
  async getToken(arg = { params: {} }) {
    const instance = axios.create({})
    if (arg.params) {
      arg.params.AppId = currentEnv.VUE_APP_APP_ID
    }
    const [err, res] = await To(
      instance.get(`${currentEnv.VUE_APP_EASC_SERVER}/sso/getToken?${qs.stringify(arg.params)}`)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
}

export default {
  methods: ApiMixin,
}
